import { Link } from 'react-router-dom';
import SeoLandingLayout from '../../components/SeoLandingLayout/SeoLandingLayout';
import { OFFICE_ADDRESS, OFFICE_MAPS_URL } from '../../config/office';

const CANONICAL = 'https://e-asy.es/donde-trabajamos';

const SERVICE_LD = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'E-ASY',
  url: CANONICAL,
  areaServed: { '@type': 'Country', name: 'España' },
  address: {
    '@type': 'PostalAddress',
    streetAddress: OFFICE_ADDRESS,
    addressLocality: 'Santa Cruz de Tenerife',
    addressRegion: 'Santa Cruz de Tenerife',
    addressCountry: 'ES',
  },
  provider: {
    '@type': 'Organization',
    name: 'E-ASY',
    url: 'https://e-asy.es',
  },
};

const FAQ = [
  {
    question: '¿Tenéis oficina fuera de Tenerife?',
    answer:
      'No. La única oficina está en Santa Cruz de Tenerife. No hay sedes en Madrid, Barcelona ni otras ciudades.',
  },
  {
    question: '¿Podéis trabajar con una empresa de la península?',
    answer:
      'Sí. El diagnóstico, el desarrollo, la implantación y el seguimiento se hacen en remoto con empresas de toda España. Nos desplazamos cuando el proyecto lo necesita.',
  },
  {
    question: '¿Qué es presencial y qué es remoto?',
    answer:
      'La atención presencial habitual está en Canarias. El resto del trabajo —reuniones, desarrollo, formación y soporte— se hace en remoto.',
  },
];

const servicios = [
  ['Consultoría tecnológica', '/servicios/consultoria-tecnologica'],
  ['ERP para pymes', '/erp-para-pymes'],
  ['Software de gestión a medida', '/servicios/software-gestion-medida'],
  ['Software para ONG', '/erp-para-ong'],
  ['IA en producción', '/servicios/ia-en-produccion'],
  ['Consultoría Azure', '/servicios/azure'],
];

const DondeTrabajamosPage = ({ darkMode, toggleDarkMode }) => (
  <SeoLandingLayout
    darkMode={darkMode}
    toggleDarkMode={toggleDarkMode}
    title="Dónde trabajamos | Oficina en Tenerife y proyectos en España | E-ASY"
    description="E-ASY tiene oficina en Santa Cruz de Tenerife y trabaja en remoto con empresas de toda España. Atención presencial en Canarias y desplazamiento cuando el proyecto lo requiere."
    keywords="consultoría tecnológica España, oficina Tenerife, proyectos remotos España, E-ASY Canarias"
    canonical={CANONICAL}
    h1="Oficina en Tenerife, proyectos en toda España"
    lede="La sede está en Santa Cruz de Tenerife. Desde ahí trabajamos en remoto con pymes y entidades de cualquier comunidad, y en presencial cuando el proyecto está en Canarias."
    faqItems={FAQ}
    serviceJsonLd={SERVICE_LD}
    serviceJsonLdId="jsonld-donde-trabajamos"
    ctaTo="/contacto"
    ctaLabel="Cuéntanos tu caso"
  >
    <h2>Cómo trabajamos según el lugar</h2>
    <ul>
      <li>
        <strong>Tenerife y Canarias:</strong> oficina, reuniones presenciales y acompañamiento en la isla.
      </li>
      <li>
        <strong>Resto de España:</strong> diagnóstico, desarrollo, implantación y soporte en remoto.
      </li>
      <li>
        <strong>Desplazamientos:</strong> cuando el arranque o la formación lo piden, nos movemos. No es una segunda oficina.
      </li>
    </ul>

    <h2>La oficina</h2>
    <p>
      {OFFICE_ADDRESS}, Santa Cruz de Tenerife.{' '}
      <a href={OFFICE_MAPS_URL} target="_blank" rel="noopener noreferrer">
        Ver en el mapa
      </a>
      . Teléfono +34 822 68 50 12.
    </p>
    <p>
      Si buscas el servicio con foco local, está en la página de{' '}
      <Link to="/consultoria-tecnologica-tenerife">consultoría tecnológica en Tenerife</Link>.
    </p>

    <h2>Servicios que prestamos en remoto</h2>
    <ul>
      {servicios.map(([label, href]) => (
        <li key={href}>
          <Link to={href}>{label}</Link>
        </li>
      ))}
    </ul>
  </SeoLandingLayout>
);

export default DondeTrabajamosPage;
